import Icon from "@mui/material/Icon";
import { useTheme } from "@mui/material/styles";
import MDTypography from "components/MDTypography";
import React from "react";
import TooltipLight from "utils/TooltipLight";

function iconTrend(prev, curr, theme, inverse, scale = "1.2") {
  let color = "";
  let icon = "";
  if (prev > curr) {
    icon = "south_east";
    color = inverse ? theme.palette.trendGreen.main : theme.palette.trendRed.main;
  } else if (prev < curr) {
    icon = "north_east";
    color = inverse ? theme.palette.trendRed.main : theme.palette.trendGreen.main;
  }
  return (
    <Icon
      sx={{
        color: { color },
        scale,
        ml: 1,
        mr: 0.5,
        "& :hover": {
          cursor: "default",
        },
      }}
    >
      {icon}
    </Icon>
  );
}

function percentageTrend(prev, curr, theme, percentage, inverse) {
  let color = "";
  let icon = "";

  if (inverse) {
    color = percentage < 0 ? theme.palette.trendGreen.main : theme.palette.trendRed.main;
  } else {
    color = percentage > 0 ? theme.palette.trendGreen.main : theme.palette.trendRed.main;
  }
  icon = iconTrend(0, percentage, theme, inverse);
  return (
    <MDTypography
      sx={{
        color: { color },
        fontSize: "0.9rem",
        fontWeight: "bold",
        "& :hover": {
          cursor: "default",
        },
      }}
      display="inline-flex"
      whiteSpace="nowrap"
      alignItems="center"
    >
      {icon}
      {Math.abs(percentage)}%
    </MDTypography>
  );
}

function Trend({
  prev,
  curr,
  type = "percent",
  explicit = false,
  inverse = false,
  displayTooltip = true,
  fieldLabel,
  overrideTitle = {},
}) {
  const theme = useTheme();
  const previous = parseFloat(prev);
  const current = parseFloat(curr);
  if (
    prev === undefined ||
    curr === undefined ||
    previous === current ||
    previous === 0 ||
    current === 0
  )
    return React.Fragment;

  const percentage = explicit ? current : Math.round(((current - previous) / previous) * 100);
  const trend = current > previous ? "increased" : "decreased";
  const overrideToolTip = overrideTitle?.start
    ? `${overrideTitle.start} ${trend} ${overrideTitle.end}`
    : "";
  const tooltip = displayTooltip
    ? `The ${
        fieldLabel ? fieldLabel.toLowerCase() : ""
      } total for this filtered period has ${trend} by ${Math.abs(
        percentage
      )}% from the previous period.`
    : "";
  return (
    <TooltipLight title={overrideToolTip || tooltip} arrow>
      {type === "percent"
        ? percentageTrend(previous, current, theme, percentage, inverse)
        : iconTrend(previous, current, theme, inverse, 0.9)}
    </TooltipLight>
  );
}

export default Trend;
